import { Injectable } from '@angular/core';
import { Http, Response, Headers, URLSearchParams } from '@angular/http';
import 'rxjs/Rx';
import { Observable } from 'rxjs/Rx';
import { ConfigService } from '../../config/config.service';
import { SessionService } from './session.service';
import { httpExtensionService } from './httpextension.service';
@Injectable()
export class EmployeesService {

    constructor(private http:  httpExtensionService, private config: ConfigService, private sessionService: SessionService) { }

    private getToken() {
        let user_token;
        if (this.sessionService.checkSessionCookie() !== undefined) {
            user_token = this.sessionService.checkSessionCookie();
        } else if (this.sessionService.checkStorageSession() != null) {
            user_token = this.sessionService.checkStorageSession();
        }

        return user_token;
    }

    private urlDataDecoded(data) {
        let searchParams = new URLSearchParams();
        for (const key in data) {
            if (data.hasOwnProperty(key)) {
                searchParams.set(key, data[key] + '');
            }
        }
        return searchParams.toString();
    }

    getAllEmployees() {
        let user_token: string = this.getToken();
        let headers = new Headers();
        headers.append('Authorization', 'Bearer ' + user_token);
        return this.http.get(this.config.apiURI + this.config.emoloyeesList, {
            headers: headers
        })
    }

    addNewEmployee(data) {
        let body = this.urlDataDecoded(data);
        let user_token: string = this.getToken();
        let headers = new Headers();
        headers.append('Authorization', 'Bearer ' + user_token);
        headers.append('Content-Type', 'application/x-www-form-urlencoded');
        return this.http.post(this.config.apiURI + this.config.addNewEmployee(), body, {
            headers: headers
        })
    }

    changeEmployeeStatus(id, status) {
        let body = this.urlDataDecoded(status);
        let user_token: string = this.getToken();
        let headers = new Headers();
        headers.append('Authorization', 'Bearer ' + user_token);
        headers.append('Content-Type', 'application/x-www-form-urlencoded');
        return this.http.put(this.config.apiURI + this.config.changeEmployeeStatus(id), body, {
            headers: headers
        })
    }

    getEmployee(id) {
        let user_token: string = this.getToken();
        let headers = new Headers();
        headers.append('Authorization', 'Bearer ' + user_token);
        return this.http.get(this.config.apiURI + this.config.getEmployee(id), {
            headers: headers
        })
    }

    updateEmployee(data, id) {
        let body = this.urlDataDecoded(data);
        let user_token: string = this.getToken();
        let headers = new Headers();
        headers.append('Authorization', 'Bearer ' + user_token);
        headers.append('Content-Type', 'application/x-www-form-urlencoded');
        return this.http.put(this.config.apiURI + this.config.updateEmployee(id), body, {
            headers: headers
        })
    }

    changeEmployeePassword(data) {
        let body = this.urlDataDecoded(data);
        let user_token: string = this.getToken();
        let headers = new Headers();
        headers.append('Authorization', 'Bearer ' + user_token);
        headers.append('Content-Type', 'application/x-www-form-urlencoded');
        return this.http.post(this.config.apiURI + this.config.changeEmployeePassword, body, {
            headers: headers
        })
    }

}



// WEBPACK FOOTER //
// ./src/app/shared/services/employees.service.ts